import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "./api";
import { useAdminAuth } from "./auth";

const EventContext = createContext(null);
export const EVENT_KEY = "ssm_event_id";

export function EventProvider({ children }) {
  const { user } = useAdminAuth();
  const [events, setEvents] = useState([]);
  const [currentId, setCurrentId] = useState(localStorage.getItem(EVENT_KEY) || null);
  const [loaded, setLoaded] = useState(false);

  const reloadEvents = useCallback(async () => {
    const { data } = await adminApi.get("/admin/events");
    setEvents(data.items || []);
    return data.items || [];
  }, []);

  useEffect(() => {
    if (!user) { setEvents([]); setLoaded(false); return; }
    reloadEvents().then((items) => {
      setCurrentId((cur) => {
        if (cur && items.some((e) => e.id === cur)) return cur;
        const fallback = items.find((e) => e.status === "active") || items[0];
        return fallback ? fallback.id : null;
      });
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, [user, reloadEvents]);

  useEffect(() => {
    if (currentId) localStorage.setItem(EVENT_KEY, currentId);
  }, [currentId]);

  const currentEvent = events.find((e) => e.id === currentId) || null;

  const value = {
    events,
    currentEvent,
    currentId,
    loaded,
    setCurrentEvent: setCurrentId,
    reloadEvents,
    isArchived: currentEvent?.status === "archived",
  };
  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
}

export const useEvents = () => useContext(EventContext);
